(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psxc-c2rw8-4"] && !Shopify.designMode) return;
  try {
    
(function(){
  function slider(el){
    var t=el.querySelector('[data-psxc-track]'); if(!t||t.dataset.ready) return; t.dataset.ready='1';
    function step(){var c=t.children[0];return c?c.getBoundingClientRect().width:t.clientWidth}
    function go(d){var max=t.scrollWidth-t.clientWidth-2;if(d>0&&t.scrollLeft>=max)t.scrollTo({left:0});else if(d<0&&t.scrollLeft<=0)t.scrollTo({left:max});else t.scrollBy({left:d*step()})}
    el.querySelectorAll('[data-psxc-prev]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(-1)})});
    el.querySelectorAll('[data-psxc-next]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(1)})});
  }
  function tabs(root){
    root.querySelectorAll('[role=tab][aria-controls]').forEach(function(tab){
      if(tab.dataset.ready) return; tab.dataset.ready='1';
      tab.addEventListener('click',function(e){
        e.preventDefault(); var list=tab.closest('[role=tablist]')||tab.parentElement;
        var tc=list.getAttribute('data-psxc-tabc'), pc=list.getAttribute('data-psxc-panc');
        list.querySelectorAll('[role=tab]').forEach(function(t){var on=t===tab;t.setAttribute('aria-selected',on);if(tc)t.classList.toggle(tc,on);var p=document.getElementById(t.getAttribute('aria-controls'));if(p){p.hidden=!on;if(pc)p.classList.toggle(pc,on)}});
      });
    });
  }
  function acc(root){
    root.querySelectorAll('[aria-expanded][aria-controls]:not([role=tab])').forEach(function(b){
      if(b.dataset.ready) return; b.dataset.ready='1';
      b.addEventListener('click',function(e){
        var p=document.getElementById(b.getAttribute('aria-controls')); if(!p) return; e.preventDefault();
        var open=b.getAttribute('aria-expanded')!=='true'; b.setAttribute('aria-expanded',open); p.hidden=!open;
        if(open){p.style.maxHeight='none';p.style.height='auto';p.style.visibility='visible';p.style.opacity='1'}
      });
    });
  }
  function cd(root){
    root.querySelectorAll('[data-psxc-cd]').forEach(function(el){
      if(el.dataset.ready) return; el.dataset.ready='1';
      var end=new Date(String(el.getAttribute('data-psxc-cd')).trim().replace(' ','T')).getTime(); if(isNaN(end)) end=Date.now()+3*864e5;
      function pad(n){return String(n).padStart(2,'0')}
      function tick(){var s=Math.max(0,Math.floor((end-Date.now())/1000));var v={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
        if(!el.querySelector('[data-psxc-u=d]')) v.h+=v.d*24;
        el.querySelectorAll('[data-psxc-u]').forEach(function(n){n.textContent=pad(v[n.getAttribute('data-psxc-u')])});}
      tick(); setInterval(tick,1000);
    });
  }
  function init(r){ (r.querySelectorAll?r:document).querySelectorAll('[data-psxc-slider]').forEach(slider); tabs(r); acc(r); cd(r); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document)}); else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
